import React, { useReducer, useEffect, useRef, useContext } from "react";
import { getAllTemplatesProduccion, addTemplateProduccion, updateTemplateProduccion, deleteTemplateProduccion } from "../../api/templateProduccion.js";

import TemplateProduccionContext from "./templateProduccionContext.js";
import TemplateProduccionReducer from "./templateProduccionReducer.js";
import { ACTUALIZAR_LIST_TEMPLATES_PRODUCCION } from "./templateProduccionActions.js";

import authContext from "../authentication/authContex.js";
import { SocketContext } from "../socket/socket.js";

const TemplateProduccionState = props => {

    const initialState = {
        templatesProduccionList: null
    };
    const server = useContext(SocketContext);

    const [state, dispatch] = useReducer(TemplateProduccionReducer, initialState);
    const templatesRef = useRef(state.templatesProduccionList);

    const ahContext = useContext(authContext);
    const { usuario, verificarTenant } = ahContext;

    const actualizarTemplatesProduccionList = async () => {
        try {
            const resp = await getAllTemplatesProduccion();
            const templates = resp.data.data;
            templatesRef.current = templates;
            dispatch({
                type: ACTUALIZAR_LIST_TEMPLATES_PRODUCCION,
                payload: templates
            });
            return templates;
        } catch (err) {
            console.log("err en actualizarTemplatesProduccionList");
            console.log(err);
        }
    };

    const agregarTemplateProduccion = async (dato) => {
        try {
            const resp = await addTemplateProduccion(dato);
            const template = resp.data.data;
            return template;
        } catch (err) {
            console.log(err);
            if (err.response?.data?.code === 'DUPLICATEKEY') return 'DUPLICATEKEY';
            return null;
        }
    };

    const modificarTemplateProduccion = async (dato) => {
        try {
            const resp = await updateTemplateProduccion(dato._id, dato);
            const template = resp.data.data;
            return template;
        } catch (err) {
            console.log(err);
        }
    };

    const eliminarTemplateProduccion = async (id) => {
        try {
            const resp = await deleteTemplateProduccion(id);
            return resp.data;
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (usuario != null) {
            actualizarTemplatesProduccionList();
        }
    }, [usuario]);

    useEffect(() => {
        if (server) {
            server.on('templateProduccionNew', ({ tenantId }) => {
                console.log("Recibo el evento del Real Time Server templateProduccionNew");
                const verification = verificarTenant(tenantId);
                if (verification) {
                    actualizarTemplatesProduccionList();
                }
            });
            server.on('templateProduccionUpdated', ({ tenantId, templateUpdated }) => {
                console.log("Recibo el evento del Real Time Server templateProduccionUpdated");
                const verification = verificarTenant(tenantId);
                if (verification) {
                    let newTemplates = templatesRef.current.map(t => t._id === templateUpdated._id ? templateUpdated : t);
                    templatesRef.current = newTemplates;
                    dispatch({
                        type: ACTUALIZAR_LIST_TEMPLATES_PRODUCCION,
                        payload: newTemplates
                    });
                }
            });
            return () => {
                server.off('templateProduccionNew');
                server.off('templateProduccionUpdated');
            };
        }
    }, [server]);

    return (
        <TemplateProduccionContext.Provider
            value={{
                templatesProduccionList: state.templatesProduccionList,
                actualizarTemplatesProduccionList,
                agregarTemplateProduccion,
                modificarTemplateProduccion,
                eliminarTemplateProduccion
            }}
        >
            {props.children}
        </TemplateProduccionContext.Provider>
    );
};

export default TemplateProduccionState;
